import { render } from "./privacy.vue?vue&type=template&id=2030d277&scoped=true"
const script = {}

import "./privacy.vue?vue&type=style&index=0&id=2030d277&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2030d277"]])

export default __exports__